<template>
  <div class="event-packages">
    <modal :title="title" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <package v-on:close="switchModal" :data="editablePackage"></package>
    </modal>
    <div class="packages-actions">
      <button v-if="permissionsStatus.isPackageCreateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить пакет
      </button>
    </div>
    <ccs-table :data="packages" :columnsDefs="columnsDefs"
      :defaultActions="defaultActions" @edit="goToPackagePage" @delete="removePackage">
      <template v-slot:roles="props">
        <span v-if="props.isEmpty">
          Не назначены
        </span>
        <span v-else>
          {{ props.row.roles.map(item => item.name).join(', ') }}
        </span>
      </template>
    </ccs-table>
    <pagination :dataFunction="getPackages"/>
    <div class="ccs-table__actions">
      <button class="ccs-button ccs-button--blight ccs-button--no-border ccs-button--small">
        <img src="@/assets/icons/file_xlsx.svg" alt="" class="button-icon">
        Скачать Excel
      </button>
      <button class="ccs-button ccs-button--blight ccs-button--no-border ccs-button--small">
        <img src="@/assets/icons/file_pdf.svg" alt="" class="button-icon">
        Скачать Pdf
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Modal from '../../components/Modal.vue';
import Package from '../../components/modals/packages/Package.vue';
import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Packages',
  components: {
    'ccs-table': Table,
    Modal,
    Package,
    Pagination,
  },
  data() {
    return {
      modal: false,
      titles: {
        new: 'Новый пакет',
        edit: 'Редактирование пакета',
      },
      columnsDefs: [{
        name: `id`,
        title: `ID`,
        prop: `id`,
      }, {
        name: `name`,
        title: 'Наименование пакета',
        prop: 'name',
      }, {
        name: `roles`,
        title: `Роли назначения`,
        fontStyle: 'secondary',
        prop: `roles`,
      }, {
        name: `price`,
        title: `Стоимость, руб`,
        prop: `price`,
        align: `right`,
      }, {
        name: `started_at`,
        title: `Доступен с`,
        prop: `started_at`,
        type: `date`,
      }, {
        name: `expired_at`,
        title: `Доступен до`,
        prop: `expired_at`,
        type: `date`,
      }],
      editablePackage: null,
    };
  },
  computed: {
    ...mapState('packages', ['packages']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editablePackage ? this.titles.edit : this.titles.new; 
    },
    defaultActions() {
      return {
        edit: this.permissionsStatus.isPackageViewAllowed,
        delete: this.permissionsStatus.isPackageDeleteAllowed,
      };
    },
  },
  methods: {
    ...mapActions('packages', ['getPackages', 'updatePackage', 'deletePackage']),
    switchModal() {
      this.modal = !this.modal;
      if (this.editablePackage) {
        this.editablePackage = null;
      }
    },
    goToPackagePage(pkg) {
      this.$router.push({ name: 'package', params: { packageID: pkg.id } });
    },
    async removePackage(pkg) {
      try {
        await this.deletePackage(pkg.id);
        this.$toasted.success('Пакет удалён');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.event-packages {
  min-height: 100%;
  min-width: 100%;

  .packages-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

  .button--add {
    margin-top: 22px;
  }

  .modal-table {
    margin-top: 30px;
  }

}
</style>
